import {
  HOME_PAGE_URL,
  ABOUT_PAGE_URL,
  REAL_TIME_URL,
  ONLINE_SESSIONS_URL,
  DUNGEON_SESSIONS_URL,
  RATES_AND_TRIBUTES_URL,
  GALLERY_PAGE_URL,
  CONTACT_PAGE_URL,
  FAQS_PAGE_URL,
  EXTRA_LINKS_URL,
} from '../Routes';

export const FooterLinksArray = [
  { name: 'Home', route: HOME_PAGE_URL },
  { name: 'About Me', route: ABOUT_PAGE_URL },
  { name: 'Real Time', route: REAL_TIME_URL },
  { name: 'Online Sessions', route: ONLINE_SESSIONS_URL },
  { name: 'Dungeon Sessions', route: DUNGEON_SESSIONS_URL },
  { name: 'Rates and Tributes', route: RATES_AND_TRIBUTES_URL },
  { name: 'Gallery', route: GALLERY_PAGE_URL },
  { name: 'Contact', route: CONTACT_PAGE_URL },
  { name: 'FAQs', route: FAQS_PAGE_URL },
  { name: 'Extra Links', route: EXTRA_LINKS_URL },
];
